/* Librerías cargadas bajo demanda (import dinámico) para no inflar el bundle principal. */

/**
 * Exporta filas a un archivo .xlsx.
 * @param {string} nombreArchivo  sin extensión
 * @param {string[]} encabezados
 * @param {Array<Array>} filas    valores crudos (números como Number para que Excel los sume)
 */
export async function exportarExcel(nombreArchivo, encabezados, filas) {
  const XLSX = await import('xlsx');
  const ws = XLSX.utils.aoa_to_sheet([encabezados, ...filas]);
  ws['!cols'] = encabezados.map((h, i) => ({
    wch: Math.min(
      40,
      Math.max(h.length, ...filas.map((f) => String(f[i] ?? '').length)) + 2,
    ),
  }));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Datos');
  XLSX.writeFile(wb, `${nombreArchivo}.xlsx`);
}

/**
 * Exporta filas a un PDF apaisado con tabla.
 * @param {string} titulo
 * @param {string} nombreArchivo  sin extensión
 * @param {string[]} encabezados
 * @param {Array<Array>} filas    valores ya formateados para mostrar
 * @param {string} [subtitulo]
 */
export async function exportarPDF(titulo, nombreArchivo, encabezados, filas, subtitulo = '') {
  const [{ jsPDF }, { default: autoTable }] = await Promise.all([
    import('jspdf'),
    import('jspdf-autotable'),
  ]);
  const doc = new jsPDF({ orientation: 'landscape' });
  doc.setFontSize(14);
  doc.setTextColor(30, 41, 59);
  doc.text(titulo, 14, 14);
  if (subtitulo) {
    doc.setFontSize(10);
    doc.setTextColor(100, 116, 139);
    doc.text(subtitulo, 14, 20);
  }
  autoTable(doc, {
    head: [encabezados],
    body: filas,
    startY: subtitulo ? 24 : 20,
    styles: { fontSize: 8, cellPadding: 2 },
    headStyles: { fillColor: [30, 41, 59], textColor: 255, fontStyle: 'bold' },
    alternateRowStyles: { fillColor: [248, 250, 252] },
  });
  doc.save(`${nombreArchivo}.pdf`);
}
